(function () {
  'use strict';

  function init() {
    var mainWrap = document.querySelector('.product-gallery__main .skeleton-img');
    if (!mainWrap) return;

    var overlay = document.getElementById('pdpZoomOverlay');
    var overlayImg = document.getElementById('pdpZoomImage');
    var closeBtn = document.getElementById('pdpZoomClose');
    var hasFinePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    function getMainImg() {
      return mainWrap.querySelector('img');
    }

    /* Desktop: cursor-follow magnify. The image itself scales up and its
       transform-origin tracks the pointer, contained by the wrapper's own
       overflow:hidden — no extra markup needed. */
    if (hasFinePointer) {
      mainWrap.addEventListener('mouseenter', function () {
        var img = getMainImg();
        if (img) img.style.transform = 'scale(1.8)';
      });
      mainWrap.addEventListener('mousemove', function (e) {
        var img = getMainImg();
        if (!img) return;
        var rect = mainWrap.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        img.style.transformOrigin = x + '% ' + y + '%';
      });
      mainWrap.addEventListener('mouseleave', function () {
        var img = getMainImg();
        if (!img) return;
        img.style.transform = '';
        img.style.transformOrigin = '';
      });
    }

    /* All devices: click/tap opens a full-size lightbox. On touch devices
       this is the only zoom affordance (hover doesn't apply), letting
       people scroll/pinch around an oversized image for detail. */
    if (!overlay || !overlayImg) return;

    function openOverlay() {
      var img = getMainImg();
      if (!img) return;
      var src = img.getAttribute('src') || '';
      var largeSrc = /[?&]width=\d+/.test(src)
        ? src.replace(/([?&])width=\d+/, '$1width=2000')
        : src;
      overlayImg.setAttribute('src', largeSrc);
      overlayImg.setAttribute('alt', img.getAttribute('alt') || '');
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeOverlay() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    mainWrap.addEventListener('click', openOverlay);
    closeBtn.addEventListener('click', closeOverlay);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeOverlay();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeOverlay();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
